import FinanceAdapter from './base';

export default class Ledger extends FinanceAdapter {
  modelNamePlural = 'ledgers';
}
